
// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import "./ServiceHome.css";
// import api, { baseURL } from "../api";

// const ServicesHome = () => {
//   const { i18n } = useTranslation();
//   const [services, setServices] = useState([]);

//   const fetchServices = async (language) => {
//     try {
//       const response = await api.get(`/services?lang=${language}`);
//       setServices(response.data);
//     } catch (error) {
//       console.error("Error fetching services data");
//     }
//   };

//   useEffect(() => {
//     fetchServices(i18n.language);
//   }, [i18n.language]);

//   return (
//     <div className="container-fluid container-fluid1">
//       <section className="service-section-new">
//         <section className="council-section service-home">
//           <div className="service-sec">
//             <div className="row align-items-center">
//               <div className="col-lg-9 col-md-12 col-sm-12 links-column">
//                 <div className="links-inner">
//                   <div className="row clearfix mb-2">
//                     {services.map((service, index) => (
//                       <div
//                         className="col-lg-4 col-md-6 col-sm-12 single-column mb-3"
//                         key={index}
//                       >
//                         <Link to={service.service_link}>
//                           <div className="single-links theme-btn btn-one">
//                             <div className="figure">
//                               <img
//                                 className="Sirv image-main sirv-image-loaded"
//                                 src={`${baseURL}/${service.main_icon_path}`}
//                                 alt=""
//                                 loading="lazy"
//                               />
//                               <img
//                                 className="Sirv image-hover sirv-image-loaded"
//                                 src={`${baseURL}/${service.hover_icon_path}`}
//                                 alt=""
//                                 loading="lazy"
//                               />
//                             </div>
//                             <h5>
//                               <span>{service.service_heading}</span>
//                             </h5>
//                           </div>
//                         </Link>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//               <div className="col-lg-3">
//                 <div className="map-style">
//                   <iframe
//                     title="Badlapur, Maharashtra Map"
//                     src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3768.6747659966063!2d73.2341407!3d19.1657087!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7930008d68315%3A0x9145cf699bfc86e0!2sKulgaon%20Badlapur%20Municipal%20Council%20New%20Building!5e0!3m2!1sen!2sin!4v1748244115274!5m2!1sen!2sin"
//                     width="100%"
//                     height="240"
//                     style={{ border: 0 }}
//                     allowFullScreen
//                     loading="lazy"
//                   ></iframe>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </section>
//     </div>
//   );
// };

// export default ServicesHome;


import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./ServiceHome.css";
import api, { baseURL } from "../api";

const ServicesHome = () => {
  const { i18n } = useTranslation();
  const [services, setServices] = useState([]);
  const [departments, setDepartments] = useState([]);

  const fetchServices = async (language) => {
    try {
      const response = await api.get(`/services?lang=${language}`);
      setServices(response.data);
    } catch (error) {
      console.error("Error fetching services data");
    }
  };

  const fetchDepartments = async (language) => {
    try {
      const response = await api.get(`/public_disclosure?lang=${language}`);
      const filtered = response.data.filter(
        (department) =>
          department.status === 1 && department.language_code === language
      );
      setDepartments(filtered);
    } catch (error) {
      console.error("Error fetching department data", error);
    }
  };

  useEffect(() => {
    fetchServices(i18n.language);
    fetchDepartments(i18n.language);
  }, [i18n.language]);

  const getRightToInfoId = () => {
    const rtiDept = departments.find(
      (dept) =>
        dept.department_link === "/right-to-information" ||
        dept.department_name?.toLowerCase().includes("right to information")
    );
    return rtiDept ? rtiDept.p_id : null;
  };

  return (
    <div className="container-fluid container-fluid1">
      <section className="service-section-new">
        <section className="council-section service-home">
          <div className="service-sec">
            <div className="row align-items-center">
              <div className="col-lg-9 col-md-12 col-sm-12 links-column">
                <div className="links-inner">
                  <div className="row clearfix mb-2">
                    {services.map((service, index) => {
                      if (service.service_link === "/right-to-information") {
                        const rtiId = getRightToInfoId();
                        return (
                          <div
                            className="col-lg-4 col-md-6 col-sm-12 single-column mb-3"
                            key={index}
                          >
                            <Link
                              to={service.service_link}
                              state={{ id: rtiId }}
                            >
                              <div className="single-links theme-btn btn-one">
                                <div className="figure">
                                  <img
                                    className="Sirv image-main sirv-image-loaded"
                                    src={`${baseURL}/${service.main_icon_path}`}
                                    alt=""
                                    loading="lazy"
                                  />
                                  <img
                                    className="Sirv image-hover sirv-image-loaded"
                                    src={`${baseURL}/${service.hover_icon_path}`}
                                    alt=""
                                    loading="lazy"
                                  />
                                </div>
                                <h5>
                                  <span>{service.service_heading}</span>
                                </h5>
                              </div>
                            </Link>
                          </div>
                        );
                      }

                      return (
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 single-column mb-3"
                          key={index}
                        >
                          <Link to={service.service_link}>
                            <div className="single-links theme-btn btn-one">
                              <div className="figure">
                                <img
                                  className="Sirv image-main sirv-image-loaded"
                                  src={`${baseURL}/${service.main_icon_path}`}
                                  alt=""
                                  loading="lazy"
                                />
                                <img
                                  className="Sirv image-hover sirv-image-loaded"
                                  src={`${baseURL}/${service.hover_icon_path}`}
                                  alt=""
                                  loading="lazy"
                                />
                              </div>
                              <h5>
                                <span>{service.service_heading}</span>
                              </h5>
                            </div>
                          </Link>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="map-style">
                  <iframe
                    title="Badlapur, Maharashtra Map"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3768.6747659966063!2d73.2341407!3d19.1657087!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7930008d68315%3A0x9145cf699bfc86e0!2sKulgaon%20Badlapur%20Municipal%20Council%20New%20Building!5e0!3m2!1sen!2sin!4v1748244115274!5m2!1sen!2sin"
                    width="100%"
                    height="240"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>
  );
};

export default ServicesHome;
